import type { FinnovaLanguage } from '.';

export enum ContactFormType {
    CONTACT = 1,
    APPOINTMENT = 2,
    EBANKING_REGISTRATION = 3,
}

export interface IContactFormSubmissionData {
    contactType: ContactFormType;
    subject: string; // maxLength: 100
    message: string; // maxLength: 1000
    topic: string; // maxLength: 60
    channel?: string; // maxLength: 60, how the user wishes to be contacted (e.g. via phone)
    branch?: string; // maxLength: 60

    company?: string; // maxLength: 35
    salutation?: string; // 1 or 2
    firstname?: string; // maxLength: 15
    lastname?: string; // maxLength: 35
    birthdate?: string; // date string 'yyyy-mm-dd'

    useAllAccountsInEBanking?: boolean;
    preferredLanguage?: FinnovaLanguage;

    street?: string; // maxLength: 25
    streetnumber?: string; // maxLength: 9
    zip?: string; // maxLength: 20
    city?: string; // maxLength: 35

    phone?: string; // maxLength: 50
    mobilePhone?: string; // maxLength: 50
    email?: string; // maxLength: 50

    accountNumbers?: string; // maxLength: 1000

    contactReference?: string; // maxLength: 60, unique identifier for the contact request if available
    bsaId?: number; // range 1000-9999
}

// these fields are required in the request, but added by the service
export interface IContactFormSubmissionRequest extends IContactFormSubmissionData {
    userbank: number; // tenant Id

    primaryCustomerId?: string; // portalId
    contextCustomerId?: string; // kdLnr

    // ISO8601 date-time
    creationTimestamp: string;

    sourceSystem: string; // maxLength: 60, calling system, e.g. "portal"
}
